/* eslint-disable max-lines */
import { Authentication, AuthenticationNext, IAuthenticationContext, Provider } from '@cian/authentication-widget';
import * as React from 'react';

import * as tracking from './tracking';

const styles = require('./AuthenticationPopup.css');

export enum EAlertType {
  Favorites = 'favorites',
  Chats = 'chats',
  Hide = 'hide',
}

export interface IAuthenticationPopupProps {
  isNewAuth?: boolean;
  userAgent?: string;
  context: IAuthenticationContext;
  disabledSocials: string[];
  alert?: EAlertType;
  onClose(): void;
}

export class AuthenticationPopup extends React.Component<IAuthenticationPopupProps> {
  private contentRef: React.RefObject<HTMLDivElement> = React.createRef<HTMLDivElement>();
  private isOutsideClickDisabled = false;

  public componentDidMount() {
    disableBodyScroll();

    tracking.trackShow();
  }

  public componentWillUnmount() {
    enableBodyScroll();
  }

  public renderWidgetComponent() {
    return this.props.isNewAuth ? (
      <AuthenticationNext userAgent={this.props.userAgent} disabledSocials={this.props.disabledSocials} showLogo />
    ) : (
      <Authentication disabledSocials={this.props.disabledSocials} />
    );
  }

  public render() {
    const { context } = this.props;

    return (
      <Provider context={context}>
        <div className={styles['wrapper']}>
          <div className={styles['container']} onClick={this.handleOutsideClick}>
            <div
              ref={this.contentRef}
              className={styles['content']}
              onMouseDown={this.handleContentMouse}
              onMouseUp={this.handleContentMouse}
            >
              {this.renderAlert()}
              {this.renderWidgetComponent()}
              <button className={styles['close']} onClick={this.handleCloseClick} />
            </div>
          </div>
        </div>
      </Provider>
    );
  }

  private renderAlert = () => {
    const { alert } = this.props;
    if (!alert) {
      return null;
    }

    let text: string;

    switch (alert) {
      case EAlertType.Chats:
        text = 'Войдите, чтобы написать сообщение';
        break;

      case EAlertType.Favorites:
        text = 'Войдите, чтобы добавлять в избранное';
        break;

      case EAlertType.Hide:
        text = 'Войдите, чтобы скрывать объявления';
        break;

      default:
        return null;
    }

    return <div className={styles['alert']}>{text}</div>;
  };

  private handleOutsideClick = (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    if (this.isOutsideClickDisabled) {
      this.isOutsideClickDisabled = false;

      return;
    }

    if (this.contentRef.current && !this.contentRef.current.contains(event.target as Node)) {
      this.props.onClose();
      tracking.trackClose();
    }
  };

  private handleContentMouse = () => {
    this.isOutsideClickDisabled = true;
  };

  private handleCloseClick = () => {
    this.props.onClose();
    tracking.trackClose();
  };
}

function disableBodyScroll() {
  document.body.style.overflow = 'hidden';
}

function enableBodyScroll() {
  document.body.style.overflow = 'visible';
}
